// extracted by mini-css-extract-plugin
export var colorSquare = "_ot-0";
export var danger = "_ot-5";
export var lightPink = "_ot-8";
export var neutralBlue = "_ot-7";
export var neutralYellow = "_ot-6";
export var normal = "_ot-1";
export var primary = "_ot-2";
export var primaryLight = "_ot-3";
export var solidBlack = "_ot-g";
export var solidGreen = "_ot-b";
export var solidLightBlue = "_ot-d";
export var solidNavy = "_ot-c";
export var solidOrange = "_ot-f";
export var solidPink = "_ot-e";
export var solidRed = "_ot-9";
export var solidYellow = "_ot-a";
export var success = "_ot-4";